/**
 * Component Registry for Sky on Main
 * 
 * Inherits from @vibesites-price-brothers/theme-vantage and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-vantage/registry';
import { Hero } from './components/Hero';
import { Header } from './components/Header';
import { FloorplansList } from './components/FloorplansList';
import { PropertyOverview } from './components/PropertyOverview';
import { NeighborhoodSection } from './components/NeighborhoodSection';
import { Footer } from './components/Footer';
import { SisterProperties } from './components/SisterProperties';
import { ContactForm } from './components/ContactForm';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { PetPolicy } from './components/PetPolicy';
import { PreferredEmployerBenefits } from './components/PreferredEmployerBenefits';
import { PreferredEmployerList } from './components/PreferredEmployerList';
import { FAQList } from './components/FAQList';
import { SitemapContent } from './components/SitemapContent';
import { LuxuryFinishes } from './components/LuxuryFinishes';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Hero,
  Header,
  FloorplansList,
  PropertyOverview,
  NeighborhoodSection,
  Footer,
  SisterProperties,
  ContactForm,
  ScheduleTourForm,
  PetPolicy,
  PreferredEmployerBenefits,
  PreferredEmployerList,
  FAQList,
  SitemapContent,
  LuxuryFinishes,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
